@if (href() || forceAnchor()) {
  <a
    [matButton]="appearance()"
    [disabled]="disabled()"
    class="Button theme-button"
    [class.Button--xsmall]="themeSize() === ButtonThemeSize.XSmall"
    [class.Button--small]="themeSize() === ButtonThemeSize.Small"
    [class.Button--medium]="themeSize() === ButtonThemeSize.Medium"
    [class.Button--large]="themeSize() === ButtonThemeSize.Large"
    [class.Button--xlarge]="themeSize() === ButtonThemeSize.XLarge"
    [class.Button--chip]="themeSize() === ButtonThemeSize.Chip"
    [class.Button--responsive-small]="themeSize() === ButtonThemeSize.ResponsiveSmall"
    [class.Button--responsive-medium]="themeSize() === ButtonThemeSize.ResponsiveMedium"
    [class.Button--responsive-large]="themeSize() === ButtonThemeSize.ResponsiveLarge"
    [class.Button--responsive-xlarge]="themeSize() === ButtonThemeSize.ResponsiveXLarge"
    [class.multi-row]="multiRow()"
    (click)="onClick()"
    [href]="href()"
    [style]="styleOverrides()"
    [attr.aria-label]="ariaLabel()"
    [target]="target()"
    data-testid="link"
  >
    <ng-container *ngTemplateOutlet="content"></ng-container>
  </a>
} @else {
  <button
    [matButton]="appearance()"
    [disabled]="disabled()"
    class="Button theme-button"
    [class.Button--xsmall]="themeSize() === ButtonThemeSize.XSmall"
    [class.Button--small]="themeSize() === ButtonThemeSize.Small"
    [class.Button--medium]="themeSize() === ButtonThemeSize.Medium"
    [class.Button--large]="themeSize() === ButtonThemeSize.Large"
    [class.Button--xlarge]="themeSize() === ButtonThemeSize.XLarge"
    [class.Button--chip]="themeSize() === ButtonThemeSize.Chip"
    [class.Button--responsive-small]="themeSize() === ButtonThemeSize.ResponsiveSmall"
    [class.Button--responsive-medium]="themeSize() === ButtonThemeSize.ResponsiveMedium"
    [class.Button--responsive-large]="themeSize() === ButtonThemeSize.ResponsiveLarge"
    [class.Button--responsive-xlarge]="themeSize() === ButtonThemeSize.ResponsiveXLarge"
    [class.multi-row]="multiRow()"
    [style]="styleOverrides()"
    [attr.aria-label]="ariaLabel()"
    data-testid="button"
  >
    <ng-container *ngTemplateOutlet="content"></ng-container>
  </button>
}
<ng-template #content>
  <div class="content-wrapper">
    <ng-content />
  </div>
</ng-template>